import { render, staticRenderFns } from "./MessageBoxInputModal.vue?vue&type=template&id=5fa10860&scoped=true&"
import script from "./MessageBoxInputModal.vue?vue&type=script&lang=js&"
export * from "./MessageBoxInputModal.vue?vue&type=script&lang=js&"
import style0 from "./MessageBoxInputModal.vue?vue&type=style&index=0&id=5fa10860&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa10860",
  null
  
)

export default component.exports